import { render, staticRenderFns } from "./MspTestItem.vue?vue&type=template&id=42df793f"
import script from "./MspTestItem.vue?vue&type=script&lang=js"
export * from "./MspTestItem.vue?vue&type=script&lang=js"
import style0 from "./MspTestItem.vue?vue&type=style&index=0&id=42df793f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports